import React, { useState } from 'react';
import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import CloseEyeIcon from '../../common/assests/eclose.svg';
import OpenEyeIcon from '../../common/assests/eopen.svg';
import CustomBtn from '../customButton/CustomBtn';
import './UserProfile.css';
import { toast } from 'react-toastify';
import { updatePasswordApi } from '../../api';
import { useSelector } from 'react-redux';

const ChangePassword = ({ onClose }) => {

  const token = useSelector((state) => state?.user?.user?.token);

  const [allPass, setAllPass] = useState({
    currentPassword: "",
    newPassword: "",
    cPassword: "",
  });

  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  });


  const handleClickShowPassword = (field) => {
    setShowPasswords((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };


  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, cPassword } = allPass;

    if (!currentPassword || !newPassword || !cPassword) {
      toast.warning("Please fill in all fields");
      return;
    }
    if (newPassword !== cPassword) {
      toast.error("New  and confirm password do not match");
      return;
    }
    if (
      newPassword.length < 8 ||
      cPassword.length < 8 ||
      currentPassword.length < 8
    ) {
      toast.error("Password should be at least 8 characters long");
      return;
    }

    try {
      const confirm = window.confirm(
        "Are you sure you want to update your password ?"
      );
      if (!confirm) {
        return;
      }
      const response = await updatePasswordApi({ allPass, token });
      // console.log("t",response);
      
      toast.success(response?.message);
      setAllPass({
        currentPassword: "",
        newPassword: "",
        cPassword: "",
      });
      onClose();
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.response?.data?.message);
      }
      console.log("error", error);
    }
  };


  const styles = {
    maxWidth: '337px'
  }

  return (
    <div>
      {/* Old Password */}
      <Typography className="change-password-label">
        Old Password
      </Typography>
      <TextField
        value={allPass.currentPassword}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setAllPass({
              ...allPass,
              currentPassword: e.target.value,
            })
          }
        }}
        className="change-password-input"
        name="oldPassword"
        type={showPasswords.oldPassword ? 'text' : 'password'}
        placeholder="Type your Old password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={showPasswords.oldPassword ? OpenEyeIcon : CloseEyeIcon}
                alt="toggle-password-visibility"
                onClick={() => handleClickShowPassword('oldPassword')}
                className="toggle-password-icon"
              />
            </InputAdornment>
          ),
        }}
      />

      {/* New Password */}
      <Typography className="change-password-label">
        New Password
      </Typography>
      <TextField
       value={allPass.newPassword}
       onChange={(e) =>
       {
         if (e.target.value.trim() !== "" || e.target.value === "") {
         setAllPass({
           ...allPass,
           newPassword: e.target.value,
         })
       }}}
        className="change-password-input"
        name="newPassword"
        type={showPasswords.newPassword ? 'text' : 'password'}
        placeholder="Type your New password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={showPasswords.newPassword ? OpenEyeIcon : CloseEyeIcon}
                alt="toggle-password-visibility"
                onClick={() => handleClickShowPassword('newPassword')}
                className="toggle-password-icon"
              />
            </InputAdornment>
          ),
        }}
      />

      {/* Retype New Password */}
      <Typography className="change-password-label">
        Retype New Password
      </Typography>
      <TextField
         value={allPass.cPassword}
         onChange={(e) =>{
           if (e.target.value.trim() !== "" || e.target.value === "") {
         
           setAllPass({ ...allPass, cPassword: e.target.value })
         }
       }
       }
        className="change-password-input"
        name="confirmNewPassword"
        type={showPasswords.confirmNewPassword ? 'text' : 'password'}
        placeholder="Retype your new password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={showPasswords.confirmNewPassword ? OpenEyeIcon : CloseEyeIcon}
                alt="toggle-password-visibility"
                onClick={() => handleClickShowPassword('confirmNewPassword')}
                className="toggle-password-icon"
              />
            </InputAdornment>
          ),
        }}
      />

      {/* Save Button */}
      <Box className="save-button-container">
        <CustomBtn text="Save" onClick={handlePasswordUpdate} style={styles} />
      </Box>
    </div>
  );
};

export default ChangePassword;
